import React, { useState, useEffect } from 'react';
import { Container, Row, Col, Button, Input, Card, CardBody, CardHeader } from "reactstrap";
import { Link, Redirect, withRouter } from "react-router-dom";
import {Table, Thead, Tbody, Tr, Th, Td} from 'react-super-responsive-table';
import { AvForm, AvField, AvInput } from "availity-reactstrap-validation";
import { uploadImage } from "../../apiHelpers/uploadApiHelper";
import TimeLineAPng from  "../../assets/images/a.png";
import { useDrag, useDrop } from 'react-dnd';

import { connect } from 'react-redux';


import { getMedia } from '../../store/actions';
import Select from "react-select";
//i18n
import { withNamespaces } from 'react-i18next';
import moment from "moment";
import Dropzone from "react-dropzone";
import { DndProvider } from 'react-dnd';
import { HTML5Backend } from 'react-dnd-html5-backend';

import DragContainer from "./Container.jsx";


const Campaign = (props) => {


    useEffect(() => {
        props.getMedia()
    }, [])

    const [layout, setLayout] = useState(1);
    const [campaignName, setCampaignName] = useState("")


    const selectLayout = (value) => {
        setLayout(parseInt(value));
    }


    const triggerAction = (value) => {
        if(value) {
            props.getMedia();
        }
    }


    return (
        <React.Fragment>
            <div className="page-content">
                <DndProvider backend={HTML5Backend}>
                    <Container fluid>
                        <button className="btn btn-primary btn-rounded mb-3" onClick={() => window.location.href = "/saved_campaigns"}>Saved Campaigns</button>
                        <Row>
                            <Col sm={12}>
                                <Card className="card-style">
                                    <CardHeader>Campaign Info</CardHeader>
                                    <CardBody>
                                        {/*<Row>*/}
                                            <AvForm  className="outer-repeater row m-auto" style={{width: "100%"}}>
                                                <Col md={6} sm={12}>
                                                    <div className="form-group">
                                                        <AvField
                                                            type="input"
                                                            label={"Name of Campaign"}
                                                            name="campaign_name"
                                                            value={campaignName}
                                                            // validate={{ required: { value: true } }}
                                                            onChange={(e) => { setCampaignName(e.target.value) }}
                                                        >
                                                        </AvField>
                                                    </div>
                                                </Col>
                                                {/*<Col md={6} sm={12}>*/}
                                                {/*    <div className="form-group">*/}
                                                {/*        <AvField type="text" label={"Folder"} name="folder">*/}
                                                {/*        </AvField>*/}
                                                {/*    </div>*/}
                                                {/*</Col>*/}
                                            </AvForm>
                                        {/*</Row>*/}
                                    </CardBody>
                                </Card>
                            </Col>
                        </Row>
                        <Row>
                            <Col sm={12}>
                                <Card className="card-style">
                                    <CardHeader>Screen Layouts</CardHeader>
                                    <CardBody>
                                        <Row>
                                            <Col md={6} lg={3} className="layout-1 mb-3" onClick={() => selectLayout(1)}>
                                                <div className={ "layout-div " + (layout === 1 ? 'thick-border' : "") }>
                                                    <div>
                                                        <h6>A</h6>
                                                        <p>Width: 1280px</p>
                                                        <p>Height: 720px</p>
                                                    </div>
                                                </div>
                                            </Col>
                                            <Col md={6} lg={3} className="layout-2 mb-3" onClick={() => selectLayout(2)}>
                                                <div className={ "layout-div " + (layout === 2 ? 'thick-border' : "") }>
                                                    <Row>
                                                        <Col xs={10} className="lay-a">
                                                            <h6>A</h6>
                                                        </Col>
                                                        <Col xs={2} className="lay-b">
                                                            <h6>B</h6>
                                                        </Col>
                                                        <Col xs={12} className="lay-c">
                                                            <h6>C</h6>
                                                        </Col>
                                                    </Row>
                                                </div>
                                            </Col>
                                            <Col md={6} lg={3} className="layout-3 mb-3" onClick={() => selectLayout(3)}>
                                                <div className={ "layout-div " + (layout === 3 ? 'thick-border' : "") }>
                                                    <Row>
                                                        <Col xs={12} className="lay-a">
                                                            <h6>A</h6>
                                                        </Col>
                                                        <Col xs={12} className="lay-b">
                                                            <h6>B</h6>
                                                        </Col>
                                                    </Row>
                                                </div>
                                            </Col>
                                            <Col md={6} lg={3} className="layout-4 mb-3" onClick={() => selectLayout(4)}>
                                                <div className={ "layout-div " + (layout === 4 ? 'thick-border' : "") }>
                                                    <Row>
                                                        <Col xs={4} className="lay-a">
                                                            <h6>A</h6>
                                                        </Col>
                                                        <Col xs={4} className="lay-b">
                                                            <h6>B</h6>
                                                        </Col>
                                                        <Col xs={4} className="lay-c">
                                                            <h6>C</h6>
                                                        </Col>
                                                    </Row>
                                                </div>
                                            </Col>
                                        </Row>
                                    </CardBody>
                                </Card>
                            </Col>
                        </Row>
                        <DragContainer getMedia={triggerAction} name={campaignName} layout={layout} media={props.media ? props.media : []} />
                    </Container>
                </DndProvider>
            </div>
        </React.Fragment>
    );
}

const mapStateToProps = state => {
    const { media } = state.CampaignReducer;
    return { media };
}

export default withRouter(connect(mapStateToProps, { getMedia })(withNamespaces()(Campaign)));
